import { ProfileSectionProps } from "./types";
import { FormSection } from "@/features/common/components/FormSection";
import { DataField } from "@/features/common/components/DataField";
import { PreparationStatusFields } from "./PreparationCourse/PreparationStatusFields";
import { CourseDetailFields } from "./PreparationCourse/CourseDetailFields";

// Label mapping function
const getStatusLabel = (value: string) => {
  const labels: { [key: string]: string } = {
    not_started: "Nicht begonnen",
    in_progress: "In Bearbeitung",
    completed: "Abgeschlossen",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    not_required: "Nicht erforderlich",
    not_applicable: "Nicht zutreffend"
  };
  return labels[value] || value;
};

export function PreparationCourseSection({
  profile,
  setProfile,
  readOnly,
  loading
}: ProfileSectionProps) {
  return (
    <FormSection title="Vorbereitungskurs">
      <div className="space-y-6">
        <PreparationStatusFields
          profile={profile}
          setProfile={setProfile}
          readOnly={readOnly}
          loading={loading}
        />

        {profile?.preparation_course_enrolled && (
          <CourseDetailFields
            profile={profile}
            setProfile={setProfile}
            readOnly={readOnly}
            loading={loading}
          />
        )}
      </div>
    </FormSection>
  );
}

// View component
export function PreparationCourseView({ profile }: { profile: any }) {
  return (
    <div className="space-y-1">
      <DataField
        label="Vorbereitungskurs Status"
        value={
          profile.preparation_course_status
            ? getStatusLabel(profile.preparation_course_status)
            : null
        }
      />
    </div>
  );
}
